export const FETCH_REIMBURSEMENT_HEADS_REQUEST = 'FETCH_REIMBURSEMENT_HEADS_REQUEST';
export const FETCH_REIMBURSEMENT_HEADS_SUCCESS = 'FETCH_REIMBURSEMENT_HEADS_SUCCESS';
export const FETCH_REIMBURSEMENT_HEADS_FAILURE = 'FETCH_REIMBURSEMENT_HEADS_FAILURE';

export const SAVE_REIMBURSEMENT_HEAD_REQUEST = 'SAVE_REIMBURSEMENT_HEAD_REQUEST';
export const SAVE_REIMBURSEMENT_HEAD_SUCCESS = 'SAVE_REIMBURSEMENT_HEAD_SUCCESS';
export const SAVE_REIMBURSEMENT_HEAD_FAILURE = 'SAVE_REIMBURSEMENT_HEAD_FAILURE';

export const CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST = 'CHANGE_REIMBURSEMENT_HEAD_STATUS_REQUEST';
export const CHANGE_REIMBURSEMENT_HEAD_STATUS_SUCCESS = 'CHANGE_REIMBURSEMENT_HEAD_STATUS_SUCCESS';
export const CHANGE_REIMBURSEMENT_HEAD_STATUS_FAILURE = 'CHANGE_REIMBURSEMENT_HEAD_STATUS_FAILURE';


// Subhead Actions
export const FETCH_REIMBURSEMENT_SUBHEADS_REQUEST = 'FETCH_REIMBURSEMENT_SUBHEADS_REQUEST';
export const FETCH_REIMBURSEMENT_SUBHEADS_SUCCESS = 'FETCH_REIMBURSEMENT_SUBHEADS_SUCCESS';
export const FETCH_REIMBURSEMENT_SUBHEADS_FAILURE = 'FETCH_REIMBURSEMENT_SUBHEADS_FAILURE';

export const SAVE_REIMBURSEMENT_SUBHEAD_REQUEST = 'SAVE_REIMBURSEMENT_SUBHEAD_REQUEST';
export const SAVE_REIMBURSEMENT_SUBHEAD_SUCCESS = 'SAVE_REIMBURSEMENT_SUBHEAD_SUCCESS';
export const SAVE_REIMBURSEMENT_SUBHEAD_FAILURE = 'SAVE_REIMBURSEMENT_SUBHEAD_FAILURE';

export const CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST = 'CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_REQUEST';
export const CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_SUCCESS = 'CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_SUCCESS';
export const CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_FAILURE = 'CHANGE_REIMBURSEMENT_SUBHEAD_STATUS_FAILURE';

export const FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST = 'FETCH_REIMBURSEMENT_MAPPED_HEADS_REQUEST';
export const FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS = 'FETCH_REIMBURSEMENT_MAPPED_HEADS_SUCCESS';
export const FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE = 'FETCH_REIMBURSEMENT_MAPPED_HEADS_FAILURE';

// mapping heads
export const FETCH_MAPPED_HEADS_REQUEST = 'FETCH_MAPPED_HEADS_REQUEST';
export const FETCH_MAPPED_HEADS_SUCCESS = 'FETCH_MAPPED_HEADS_SUCCESS';
export const FETCH_MAPPED_HEADS_FAILURE = 'FETCH_MAPPED_HEADS_FAILURE';

export const SAVE_MAPPED_HEAD_REQUEST = 'SAVE_MAPPED_HEAD_REQUEST';
export const SAVE_MAPPED_HEAD_SUCCESS = 'SAVE_MAPPED_HEAD_SUCCESS';
export const SAVE_MAPPED_HEAD_FAILURE = 'SAVE_MAPPED_HEAD_FAILURE';

export const CHANGE_MAPPED_HEAD_STATUS_REQUEST = 'CHANGE_MAPPED_HEAD_STATUS_REQUEST';
export const CHANGE_MAPPED_HEAD_STATUS_SUCCESS = 'CHANGE_MAPPED_HEAD_STATUS_SUCCESS';
export const CHANGE_MAPPED_HEAD_STATUS_FAILURE = 'CHANGE_MAPPED_HEAD_STATUS_FAILURE';

export const FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST = 'FETCH_REIMBURSEMENT_GRID_HEADS_REQUEST';
export const FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS = 'FETCH_REIMBURSEMENT_GRID_HEADS_SUCCESS';
export const FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE = 'FETCH_REIMBURSEMENT_GRID_HEADS_FAILURE';

export const FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST = 'FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_REQUEST';
export const FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS = 'FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_SUCCESS';
export const FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE = 'FETCH_REIMBURSEMENT_MAPPED_SUB_HEADS_FAILURE';